export default class Scroll {

    static disableBodyScroll() {
        const html = document.documentElement;
        html.style.overflow = 'hidden';
    }

    static enableBodyScroll() {
        const html = document.documentElement;
        html.style.overflow = null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/method/Scroll.ts